import { Card, CardBody, Col } from "reactstrap";
import CardHeaderCommon from "../../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import { MarketOverviewHeading } from "../../../../utils/Constant";
import ReactApexChart from "react-apexcharts";
import { marketOverviewChartData } from "../../../../Data/Dashboard/DashboardCharts/DashboardCharts";

const MarketOverview = () => {
  return (
    <Col xl="6" className="proorder-xl-7 proorder-lg-8">
      <Card className="market-overview">
        <CardHeaderCommon title={MarketOverviewHeading} mainTitle={"Yearly"} firstItem={"Today"} secondItem="Tomorrow" thirdItem="Yesterday" />
        <CardBody className="pt-0">
          <ReactApexChart options={marketOverviewChartData} series={marketOverviewChartData.series} type="candlestick" height={340} />
        </CardBody>
      </Card>
    </Col>
  );
};

export default MarketOverview;
